/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';

import { useGlobal } from '../../contexts/Global/context';

import Icon from '../Icons';

import * as S from './styles';
import { CustomIconButton } from '../../styles/styles';

function Accordion({ title, children, hasHeader = true, hasCollapse = true, initOpened = true }) {
    const [opened, setOpened] = useState(initOpened);

    const { contrastTheme } = useGlobal();

    function handleCollapse() {
        if (!hasCollapse) return;

        setOpened(!opened);
    }

    const colorGroup = hasCollapse && contrastTheme ? '#FFF333' : !hasCollapse && contrastTheme ? '#FFFFFF' : '#000000';
    const colorGroupLine =
        hasCollapse && contrastTheme ? '#FFF333' : !hasCollapse && contrastTheme ? '#FFFFFF' : '#5B5B5F';

    return (
        <S.StyledAccordion>
            {hasHeader && (
                <>
                    <S.StyledAccordionSummary hasCollapse={hasCollapse} opened={opened} onClick={handleCollapse}>
                        <S.StyledTitle style={{ color: `${colorGroup}` }}>{title}</S.StyledTitle>
                        {hasCollapse && (
                            <CustomIconButton
                                type="button"
                                id="select-icon"
                                isOnFocus={opened}
                                onClick={handleCollapse}
                            >
                                <Icon name="ArrowDown" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                            </CustomIconButton>
                        )}
                    </S.StyledAccordionSummary>
                    {title && <S.Sep style={{ backgroundColor: `${colorGroupLine}` }} />}
                </>
            )}
            <S.StyledAccordionDetails className={opened ? 'open' : 'closed'}>{children}</S.StyledAccordionDetails>
        </S.StyledAccordion>
    );
}

export default Accordion;
